import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import LoupeIcon from "@mui/icons-material/Loupe";
import { Button, Modal } from "react-bootstrap";
import DetalleGasto from "./detalleGasto";

const ListarGastos = () => {
  const { idPrograma } = useParams();
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const [gastos, setGastos] = useState([]);
  const [gastoSeleccionado, setGastoSeleccionado] = useState();
  const [gastosFiltrados, setGastosFiltrados] = useState([]);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [error, setError] = useState();

  const [filtros, setFiltros] = useState({
    programa: "",
    rubro: "",
    proveedor: "",
    centroCosto: "",
    ordenarPorFecha: "desc",
  });

  const [paginaActual, setPaginaActual] = useState(1);
  const itemsPorPagina = 10;

  useEffect(() => {
    const obtenerGastos = async () => {
      try {
        let response = await fetch(`${apiUrl}/gasto`, {
          headers: {
            "Content-Type": "application/json",
            apiKey: localStorage.getItem("apiKey"),
          },
        });

        if (response.ok) {
          let data = await response.json();
          setGastos(data);
          setGastosFiltrados(data);
        } else {
          manejarErrores(response.status);
        }
      } catch (error) {
        manejarErrores(error.status);
      }
    };

    obtenerGastos();
  }, [apiUrl, idPrograma]);

  useEffect(() => {
    filtrarYOrdenarGastos();
  }, [filtros, gastos]);

  const filtrarYOrdenarGastos = () => {
    let filtrados = [...gastos];

    if (filtros.programa) {
      filtrados = filtrados.filter(g =>
        g.nombrePrograma.toLowerCase().includes(filtros.programa.toLowerCase())
      );
    }

    if (filtros.rubro) {
      filtrados = filtrados.filter(g =>
        g.rubro.toLowerCase().includes(filtros.rubro.toLowerCase())
      );
    }

    if (filtros.proveedor) {
      filtrados = filtrados.filter(g =>
        g.proveedor.toLowerCase().includes(filtros.proveedor.toLowerCase())
      );
    }

    if (filtros.centroCosto) {
      filtrados = filtrados.filter(g =>
        g.centroCosto.toLowerCase().includes(filtros.centroCosto.toLowerCase())
      );
    }

    filtrados.sort((a, b) => {
      const dateA = new Date(a.fecha);
      const dateB = new Date(b.fecha);
      return filtros.ordenarPorFecha === "asc" ? dateA - dateB : dateB - dateA;
    });

    setGastosFiltrados(filtrados);
  };

  const handleFiltroCambio = (e) => {
    const { name, value } = e.target;
    setFiltros(prev => ({ ...prev, [name]: value }));
  };

  const aprobarGasto = async (gasto) => {
    try {
      const response = await fetch(`${apiUrl}/Gasto/Aprobar?id=${gasto.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          apiKey: localStorage.getItem("apiKey"),
        },
      });

      if (response.ok) {
        setGastos(prev =>
          prev.map(g => g.id === gasto.id ? { ...g, estado: "Aprobado" } : g)
        );
        setGastosFiltrados(prev =>
          prev.map(g => g.id === gasto.id ? { ...g, estado: "Aprobado" } : g)
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const manejarErrores = (estatus) => {
    setError("Error en la solicitud");
    toast.error(error);
    navigate("/dashboardCoordinador");
  };

  const registrarCajaChica = () => navigate("/FormCajaChica");

  const indexOfLast = paginaActual * itemsPorPagina;
  const indexOfFirst = indexOfLast - itemsPorPagina;
  const gastosPagidados = gastosFiltrados.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(gastosFiltrados.length / itemsPorPagina);

  return (
    <div className="container-fluid px-4" style={{ marginTop: "6rem" }}>

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold mb-0">Gastos</h4>
          <small className="text-muted">Historial de gastos</small>
        </div>

        {localStorage.getItem("rol") === "coordinador" && (
          <button className="btn btn-primary" onClick={registrarCajaChica}>
            + Registrar gasto
          </button>
        )}
      </div>

      {/* FILTROS */}
      <div className="card shadow-sm mb-3">
        <div className="card-body">
          <div className="row g-2">
            <div className="col-md-3">
              <input className="form-control" placeholder="Programa"
                name="programa" value={filtros.programa} onChange={handleFiltroCambio} />
            </div>
            <div className="col-md-2">
              <input className="form-control" placeholder="Rubro"
                name="rubro" value={filtros.rubro} onChange={handleFiltroCambio} />
            </div>
            <div className="col-md-2">
              <input className="form-control" placeholder="Proveedor"
                name="proveedor" value={filtros.proveedor} onChange={handleFiltroCambio} />
            </div>
            <div className="col-md-3">
              <input className="form-control" placeholder="Centro de costo"
                name="centroCosto" value={filtros.centroCosto} onChange={handleFiltroCambio} />
            </div>
            <div className="col-md-2">
              <select className="form-select"
                name="ordenarPorFecha"
                value={filtros.ordenarPorFecha}
                onChange={handleFiltroCambio}>
                <option value="desc">Más recientes</option>
                <option value="asc">Más antiguos</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* TABLA */}
      <div className="card shadow-sm">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>Programa</th>
                  <th>Rubro</th>
                  <th>Proveedor</th>
                  <th>Importe</th>
                  <th>Moneda</th>
                  <th>Fecha</th>
                  <th>Estado</th>
                  <th>Comprobante</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {gastosPagidados.map(g => (
                  <tr key={g.id}>
                    <td className="fw-semibold">{g.nombrePrograma}</td>
                    <td>{g.rubro}</td>
                    <td>{g.proveedor}</td>
                    <td>${g.importe}</td>
                    <td>{g.moneda}</td>
                    <td>{new Date(g.fecha).toLocaleDateString('es-ES')}</td>
                    <td>
                      <span className={`badge ${g.estado === "Aprobado" ? "bg-success" : "bg-warning text-dark"}`}>
                        {g.estado}
                      </span>
                    </td>
                    <td>
                      {g.linkComprobante &&
                        <a href={g.linkComprobante} target="_blank" rel="noreferrer">
                          Ver
                        </a>
                      }
                    </td>
                    <td className="text-end">
                      {g.estado !== "Aprobado" &&
                        localStorage.getItem("rol")?.toLowerCase() === "finanzas" && (
                          <button className="btn btn-sm btn-outline-success"
                            onClick={() => aprobarGasto(g)}>
                            <LoupeIcon fontSize="small" />
                          </button>
                        )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {gastosPagidados.length === 0 && (
            <div className="p-3 text-center text-muted">
              No hay gastos con estos filtros
            </div>
          )}
        </div>
      </div>

      {/* PAGINACIÓN */}
      <nav className="mt-3">
        <ul className="pagination justify-content-center">
          <li className={`page-item ${paginaActual === 1 ? "disabled" : ""}`}>
            <button className="page-link" onClick={() => setPaginaActual(paginaActual - 1)}>
              Anterior
            </button>
          </li>
          {[...Array(totalPages).keys()].map(page => (
            <li key={page} className={`page-item ${paginaActual === page + 1 ? "active" : ""}`}>
              <button className="page-link" onClick={() => setPaginaActual(page + 1)}>
                {page + 1}
              </button>
            </li>
          ))}
          <li className={`page-item ${paginaActual === totalPages ? "disabled" : ""}`}>
            <button className="page-link" onClick={() => setPaginaActual(paginaActual + 1)}>
              Siguiente
            </button>
          </li>
        </ul>
      </nav>

      <Modal size="lg" show={mostrarModal} onHide={() => setMostrarModal(false)}>
        <DetalleGasto idGasto={gastoSeleccionado} />
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default ListarGastos;